import Api from '../Api.js'

const contexto = "cliente"
//const contexto = "clientest"
const ctxDet = "vendas-detalhe"
const ctxVenda = "vendas"


export class ApiFac extends Api{
    
    constructor(){
        super()
    }

    async getUsuario(id=-1){
        return await super.get('usuario', id)
    }

    async getCliente(id=-1, dataInicial="", dataFinal="", empresa, page=""){
        return await super.get(contexto, id, dataInicial, dataFinal, empresa, page)
    }

    async saveCliente(obj){
        return await super.save(contexto, obj)
    }

    async desativarCliente(obj){
        return await super.saveParcial(contexto, obj)
    }

    async deleteCliente(id){
        return await super.delete(contexto, id)
    }
   
   
    async getVenda(id=-1, dataInicial="", dataFinal="", empresa="", tipo_movimento=""){
        return await super.get(ctxVenda, id, dataInicial, dataFinal, empresa, tipo_movimento)
    }
    
    async getCancela(id=-1, dataInicial="", dataFinal="", empresa="", tipo_movimento=""){
        return await super.get(`vendas/${id}/cancela`, id, dataInicial, dataFinal, empresa, tipo_movimento)
    }

    async saveBloqueio(obj){
        return await super.save('bloqueio', obj)
    }
    async desbloquearVenda(obj){
        return await super.save('bloqueio', obj)
    }
    async getBloqueio(id=-1, ){
        return await super.get('bloqueio', id)
    }
    async getBloqueioByName(termo){
        return await super.get("bloqueio/by-name", termo)
    }

    async saveVenda(obj){
        return await super.save(ctxVenda, obj)
    }

    async saveDetalheVenda(obj){
        return await super.save(ctxDet, obj)
    }

    async deleteDetalhe(id){
        return await super.delete(ctxDet, id)
    }
    async getClienteByName(termo){
        return await super.get("cliente/by-name", termo)
    }
    async getAniversariantes(empresa){
        return await super.get("cliente/aniversariantes", empresa)
    }
    async getFornecedorByName(termo){
        return await super.get("fornecedor/by-name", termo)
    }
    async getProdutoByName(termo){
        return await super.get("produto/by-descricao", termo)
    }
    async getProdutos(id){
        return await super.get("produto", id)
    }

    /* NACIONALIDADE */
    async getNacionalidade(id=-1){
        return await super.get('nacionalidade', id)
    }

    /* PAÍSES */
    async getPais(id=-1){
        return await super.get('pais', id)
    }

    /* ESTADOS */
    async getEstado(id=-1){
        return await super.get('estado', id)
    }

    /* CIDADES */
    async getCidade(id=-1){
        return await super.get('cidade', id)
    }

    /* CIDADES */
    async getProfissao(id=-1){
        return await super.get('profissao', id)
    }


    /* COMANDAS */
    async saveComanda(obj){
        return await super.save('comanda', obj)
    }

    async getComanda(id=-1, dataInicial="", dataFinal="", empresa="", tipo_movimento="", conta="", busca="", emAberto="", consultoria=""){
        return await super.get('comanda', id, dataInicial, dataFinal, empresa, tipo_movimento, conta, busca, emAberto, consultoria)
    }

    async getCancelarComanda(id=-1){
        //return await super.get(`comanda/${id}/cancelar`, id, dataInicial, dataFinal, empresa, tipo_movimento)
        return await super.get(`comanda/${id}/cancelar` )
    }

    async getDesistenciaComanda(id=-1){
        return await super.get(`comanda/${id}/desistencia` )
    }

    /* async getComanda(id=-1){
        return await super.get('comanda', id)
    } */



    /* COLABORADORES */
    async getColaborador(id=-1, dataInicial="", dataFinal="", empresa=""){
        
        return await super.get('colaborador',id, dataInicial, dataFinal, empresa)
    }

    async saveColaborador(obj){
        return await super.save('colaborador', obj)
    }

    async desativarColaborador(obj){
        return await super.saveParcial('colaborador', obj)
    }

    async deleteColaborador(id){
        return await super.delete('colaborador', id)
    }

    async getColaboradorByName(termo){
        return await super.get("colaborador/by-name", termo)
    }


    /* MEDIDAS */
    async saveMedida(obj){
        return await super.save('medida', obj)
    }
    async delMedida(id){
        return await super.delete('medida', id)
    }
}